import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';
import * as Colors from '../../utils/Color';
import { Field } from 'react-form';
import { validate } from '../../utils/validation';

const defaultStyles = {
    labelStyles: {
        fontWeight: "bold",
        marginLeft: "7px",
        fontSize: "14px",
        width: "100%",
    },
    uncheckedIconColor: {
        fill: Colors.primary,
        marginRight: 0
    },
    parentElement: {
        width: null,
        display: 'block'
    }
};

const headingStyles = {
    labelStyles: {
        fontWeight: "bold",
        marginLeft: "7px",
        fontSize: "16px",
        width: "auto",
    },
    uncheckedIconColor: {
        fill: Colors.primary,
        marginRight: 0
    },
    parentElement: {
        width: null,
        display: 'block',
        padding: '12px 20px 0',
    }
};

class CheckboxElement extends Component {

    componentDidMount() {

    }

    render() {
        const styles = this.props.heading ? headingStyles : defaultStyles;
        const { name, onChange, label, value, error } = this.props;
        return (
            <Checkbox
                name={ name }
                checked={ value }
                onCheck={(e, isInputChecked) => onChange(name, isInputChecked)}
                label={label}
                style={styles.parentElement}
                labelStyle={styles.labelStyles}
                iconStyle={styles.uncheckedIconColor}
            />
        );
    }

}




export default CheckboxElement;



// WEBPACK FOOTER //
// ./src/components/UI/Checkbox-f.js